import React from "react";
import { applyTransformations } from "../../../utils";
import { IHero } from "../../../interfaces";
import classNames from "classnames";
import CmsMarkdown from "../../basic/cms-markdown";
import CmsLink from "../../links/cms-link";
import SVG from "../../svg";

import { center_children } from "./styles.module.scss";

const Hero = (props: IHero) => {
  const { content, button, background_color, has_background_cutout, children } = props;
  const fullWidth = content && content.align_text !== "left";
  const cssOverrides = props.css_override?.add_classes;
  const backgroundImage = props.background_image?.data?.attributes;

  const getBackgroundImage = () => {
    if (backgroundImage == null) return {};
    const { url } = backgroundImage;

    return {
      backgroundImage: `url(${applyTransformations(url, { w: 1700 })}`
    };
  };

  const classes = classNames(
    "cms-hero",
    "background-image-cover",
    `cms-hero-${props.id}`,
    cssOverrides,
    {
      "empty-hero": content === null,
      "hero-background-cutout": has_background_cutout
    }
  );

  return (
    <>
      {has_background_cutout && (
        <div style={{ height: "0px" }}>
          <SVG name="hero-cutout" />
        </div>
      )}
      <div className={classes} style={getBackgroundImage()}>
        {background_color && (
          <div
            style={{ backgroundColor: background_color }}
            className={classNames("color-overlay", {
              "has-background-image": backgroundImage
            })}
          />
        )}
        {content && (
          <div
            className={`hero-content-wrapper container-lg d-flex flex-column py-${
              has_background_cutout ? 8 : 10
            } p-responsive`}
          >
            <div className="col-12">
              <div
                className={`col-md-9 col-lg-${fullWidth || has_background_cutout ? "9" : "7"} ${
                  fullWidth ? "mx-auto" : ""
                }`}
              >
                <CmsMarkdown content={content} />
                <CmsLink link={button} classnames={["btn", "f3", "mt-2"]} />
              </div>
            </div>
          </div>
        )}
        {!content && children && <div className={center_children}>{children}</div>}
      </div>
    </>
  );
};

export default Hero;
